<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="visible"
    width="584px"
    top="22vh"
    append-to-body
    center
    custom-class="dialog-adult"
    @close="onClose"
  >
    <div slot="title" class="title">
      身份认证
    </div>
    <div class="tips">
      <img src="@/assets/icons/icon-tips.png" alt="" />
      <span>
        为帮助未成年人防沉迷保护，请尽快填身份信息，身份信息将严格保密;gamekee健康系统提示您:
        未填写身份信息将无法浏览全部内容哦，已填写身份信息但未满18周岁，也无法浏览部分内容
      </span>
    </div>
    <div class="form-content">
      <div class="form-line">
        <div class="label">真实姓名</div>
        <div class="value">
          <el-input v-model="form.name" placeholder="请输入您的真实姓名" size="default" style="width: 100%;">
          </el-input>
        </div>
      </div>
      <div class="form-line">
        <div class="label">身份证号</div>
        <div class="value">
          <el-input v-model="form.idcard" placeholder="请输入您的身份证号" size="default" style="width: 100%;">
          </el-input>
        </div>
      </div>
      <div class="btn-line">
        <el-button :loading="loading" class="btn" @click="handleSubmit">提交</el-button>
      </div>
    </div>
    <div class="notice-info">
      <div class="notice">隐私声明</div>
      <div class="des">
        用户填写的身份信息属于用户个人隐私，gamekee 严格保护用户个人信息，不公开、编辑或透露用户信息
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { apiVerifyIdcard } from "@/api/contentApi";

export default {
  data() {
    return {
      visible: false,
      form: {
        name: "",
        idcard: ""
      },
      loading: false
    };
  },
  methods: {
    onClose() {
      this.visible = false;
    },
    handleSubmit() {
      if (!this.form.name) {
        this.$message.warning("请输入真实姓名");
        return;
      }
      if (!this.form.idcard) {
        this.$message.warning("请输入身份证号");
        return;
      }
      const params = {
        id_card: this.form.idcard,
        id_name: this.form.name
      };
      this.loading = true;
      apiVerifyIdcard(params)
        .then(res => {
          if (res.code === 0) {
            window.location.reload();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .dialog-adult {
  .title {
    color: #333;
    font-size: 18px;
    font-weight: bold;
  }
  .tips {
    margin-bottom: 22px;
    padding: 12px;
    border-radius: 16px;
    background-color: #f9f9f9;
    color: rgba(0, 0, 0, 0.6);
    font-size: 13px;
    img {
      width: 13px;
      height: 13px;
    }
  }
  .form-content {
    width: 100%;
    .form-line {
      display: flex;
      align-items: center;
      margin-bottom: 12px;

      .label {
        width: 76px;
        color: #333;
        font-size: 14px;
      }
      .value {
        flex: 1;
      }
    }
    .btn-line {
      display: flex;
      justify-content: center;
      width: 100%;
      margin-top: 30px;
      .btn {
        width: 348px;
        height: 36px;
        padding: 0;
        line-height: 36px;
        text-align: center;
        border-radius: 18px;
        border: none;
        background-color: #198ff8;
        color: #fff;
        font-size: 16px;
      }
    }
  }
  .notice-info {
    margin-top: 32px;
    .notice {
      margin-bottom: 4px;
      font-size: 12px;
      color: rgba(51, 51, 51, 0.6);
      font-weight: bold;
    }
    .des {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: rgba(51, 51, 51, 0.6);
    }
  }
}
</style>
